import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=2850be47"
import script from "./PermissionPage.vue?vue&type=script&lang=js"
export * from "./PermissionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports